import { bool, shape, string } from "prop-types";

import profileProps from "./profileProps";

const contactProps = {
  id: string,
  name: string,
  business_name: string,
  user_id: string,
  is_pro: bool,
  photo_uri: string,
  image: shape({
    url: string
  }),
  industry_professional: shape({
    headshot: shape({
      url: string
    })
  }),
  profile: shape(profileProps),
  license: shape({
    id: string,
    display_type: string
  }),
  full_business_address: string
};

export default contactProps;
